import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PopupSliceState {
    isShown: boolean;
    text: string;
}

const initialState: PopupSliceState = {
    isShown: false,
    text: '',
};

export const popupSlice = createSlice({
    name: 'popup',
    initialState,
    reducers: {
        show(state: PopupSliceState, action: PayloadAction<string>): PopupSliceState {
            const text = action.payload;
            return { ...state, text, isShown: true };
        },
        hide(state: PopupSliceState) {
            return { ...state, isShown: false };
        },
    },
});

export const { show, hide } = popupSlice.actions;
